// export * from "./sorters"
// export * from "./filters"
// export * from "./mappers"
// export * from "./reducers"
import * as map from "./mappers";
import * as sort from "./sorters";
import * as filter from "./filters";
import * as reduce from "./reducers";
function composer(method, data, name) {
    return { name, method, cb: data[name] };
}
export const allComposables = [
    ...Object.keys(map).map(composer.bind(void 0, "map", map)),
    ...Object.keys(sort).map(composer.bind(void 0, "sort", sort)),
    ...Object.keys(reduce).map(composer.bind(void 0, "reduce", reduce)),
    ...Object.keys(filter).map(composer.bind(void 0, "filter", filter))
].reduce((a, b) => {
    a[b.name] = b;
    return a;
}, {});
//# sourceMappingURL=index.js.map